"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Endpoints = exports.Endpoints = {
  blocked: {
    namespace: "UserBlacklist",
    actions: {
      add: { method: "POST", path: "blocks" },
      delete: { method: "DELETE", path: "blocks/#{blocked_id}" }
    }
  },
  batch_questions: {
    namespace: "BatchQuestion",
    actions: {
      create: { method: "POST", path: "batch_questions" }
    }
  },
  examining_boards: {
    namespace: "ExaminingBoard",
    actions: {
      list: { method: "GET", path: "examining_boards" },
      update: { method: "PUT", path: "examining_boards/#{slug}" }
    }
  },
  disciplines: {
    namespace: "Discipline",
    actions: {
      list: { method: "GET", path: "disciplines" }
    }
  },
  directed_sheet: {
    namespace: "DirectedSheet",
    actions: {
      list: { method: "GET", path: "directed_sheet/highlight_articles" }
    }
  },
  institutes: {
    namespace: "Institute",
    actions: {
      list: { method: "GET", path: "institutes" }
    }
  },
  jobs: {
    namespace: "Job",
    actions: {
      list: { method: "GET", path: "jobs" }
    }
  },
  favorites: {
    namespace: "Favorite",
    actions: {
      create: { method: "POST", path: "favorites" },
      delete: { method: "DELETE", path: "favorites" }
    }
  },
  relationships: {
    namespace: "Relationship",
    actions: {
      create: { method: "POST", path: "relationships" },
      delete: { method: "DELETE", path: "relationships" }
    }
  },
  users: {
    namespace: "User",
    custom: true,
    actions: {
      list: { method: "GET", path: "users" },
      show: { method: "GET", path: "users/#{user_id}" },
      update: { method: "PATCH", path: "users/#{user_id}" },
      send_email_confirmation: {
        method: "POST",
        path: "users/#{user_id}/send_email_confirmation"
      },
      give_bonus: {
        method: "POST",
        path: "users/#{user_id}/bonus"
      },
      restore: {
        method: "POST",
        path: "users/#{user_id}/restoration"
      },
      used_resources: {
        method: 'GET',
        path: "users/#{user_id}/used_resources"
      },
      subscription_transactions: {
        method: 'GET',
        path: "users/#{user_id}/subscription_transactions"
      },
      histories: {
        method: 'GET',
        path: "users/#{user_id}/histories"
      }
    }
  },
  user_info: {
    namespace: "UserInfo",
    actions: {
      show: {
        method: "GET",
        path: "user_infos"
      },
      update: {
        method: "PATCH",
        path: "user_infos"
      }
    }
  },
  user_profile: {
    namespace: "UserProfile",
    actions: {
      show: {
        method: "GET",
        path: "user_profile"
      },
      update: {
        method: "PATCH",
        path: "user_profile"
      }
    }
  },
  user_blacklist: {
    namespace: "UserBlacklist",
    actions: {
      create: {
        method: "POST",
        path: "user_blacklists"
      },
      delete: {
        method: "DELETE",
        path: "user_blacklists/#{id}"
      }
    }
  },
  user_guides: {
    namespace: "UserGuide",
    actions: {
      create: { method: "POST", path: "user/guides" },
      delete: { method: "DELETE", path: "user/guides/#{id}" }
    }
  },
  subscriptions: {
    namespace: "Subscriptions",
    actions: {
      list: {
        method: "GET",
        path: "subscriptions"
      }
    }
  },
  exams: {
    namespace: "Exam",
    custom: true,
    actions: {
      list: { method: "GET", path: "exams" },
      update: { method: "PUT", path: "exams/#{slug}" },
      request: { method: "POST", path: "exams/#{id}/exam_requests" }
    }
  },
  notebooks: {
    namespace: "Notebook",
    actions: {
      list: { method: "GET", path: "notebooks" },
      update: { method: "PUT", path: "notebooks/#{id}" },
      delete: { method: "DELETE", path: "notebooks/#{id}" },
      create: { method: "POST", path: "notebooks" }
    }
  },
  notebooks_questions: {
    namespace: "NotebookQuestion",
    actions: {
      create: { method: "POST", path: "note_book/questions" },
      delete: { method: "DELETE", path: "note_book/questions/#{id}" }
    }
  },
  stored_filters: {
    namespace: "StoredFilter",
    actions: {
      create: { method: "POST", path: "stored_filters" },
      show: { method: "GET", path: "stored_filters/#{id}" },
      update: { method: "PUT", path: "stored_filters/#{id}" },
      delete: { method: "DELETE", path: "stored_filters/#{id}" },
      list: { method: "GET", path: "stored_filters" }
    }
  },
  questions: {
    namespace: "Question",
    custom: true,
    actions: {
      resolve: { method: "POST", path: "questions/#{id}/answer" },
      list: { method: "GET", path: "questions" },
      request_professor_commentary: {
        method: "POST",
        path: "professor_commentary_requests"
      }
    }
  },
  contests: {
    namespace: "Contest",
    actions: {
      list: { method: "GET", path: "contests" },
      show: { method: "GET", path: "contests/#{id}" }
    }
  },
  annotations: {
    namespace: "Annotation",
    actions: {
      create: { method: "POST", path: "annotations" },
      update: { method: "PUT", path: "annotations/#{id}" },
      delete: { method: "DELETE", path: "annotations/#{id}" }
    }
  },
  lesson_annotations: {
    namespace: "LessonAnnotation",
    actions: {
      create: { method: "POST", path: "lesson_annotations" },
      update: { method: "PUT", path: "lesson_annotations/#{id}" },
      delete: { method: "DELETE", path: "lesson_annotations/#{id}" }
    }
  },
  activities: {
    namespace: "Activity",
    custom: true,
    actions: {
      list: { method: "GET", path: "activities" },
      create: { method: "POST", path: "activities" },
      create_and_render: {
        method: "POST",
        path: "activities/create_and_render"
      },
      report_abuse: { method: "POST", path: "activities/#{id}/report_abuse" },
      delete: { method: "DELETE", path: "activities/#{id}" }
    }
  },
  activity_comments: {
    namespace: "ActivityComments",
    custom: true,
    actions: {
      list: { method: "GET", path: "activities/#{activity_id}/comments" },
      create: { method: "POST", path: "activities/#{activity_id}/comments" },
      create_and_render: {
        method: "POST",
        path: "activities/#{activity_id}/comments/create_and_render"
      },
      update: {
        method: "PUT",
        path: "activities/#{activity_id}/comments/#{id}"
      },
      report_abuse: {
        method: "POST",
        path: "activities/#{activity_id}/comments/#{id}/report_abuse"
      },
      delete: {
        method: "DELETE",
        path: "activities/#{activity_id}/comments/#{id}"
      }
    }
  },
  activity_replies: {
    namespace: "ActivityReplies",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies"
      },
      create: {
        method: "POST",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies"
      },
      create_and_render: {
        method: "POST",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/create_and_render"
      },
      update: {
        method: "PUT",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/#{id}"
      },
      report_abuse: {
        method: "POST",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/#{id}/report_abuse"
      },
      delete: {
        method: "DELETE",
        path: "activities/#{activity_id}/comments/#{activity_comment_id}/replies/#{id}"
      }
    }
  },
  question_errors: {
    namespace: "QuestionError",
    actions: { create: { method: "POST", path: "question_errors" } }
  },
  comment_feedbacks: {
    namespace: "CommentFeedback",
    actions: {
      create: { method: "POST", path: "comment_feedbacks" },
      update: { method: "PUT", path: "comment_feedbacks/#{id}" }
    }
  },
  recommended_comment_feedbacks: {
    namespace: "RecommendedCommentFeedback",
    actions: {
      create: { method: "POST", path: "recommended_comment_feedbacks" },
      update: { method: "PUT", path: "recommended_comment_feedbacks/#{id}" }
    }
  },
  monitor_comment_feedbacks: {
    namespace: "MonitorCommentFeedback",
    actions: {
      create: { method: "POST", path: "monitor_comment_feedbacks" },
      update: { method: "PUT", path: "monitor_comment_feedbacks/#{id}" }
    }
  },
  practice_tests_questions: {
    namespace: "PracticeTestsQuestions",
    actions: {
      update: {
        method: "PUT",
        path: "practice_tests/#{practice_test_id}/practice_tests_questions/#{id}"
      }
    }
  },
  practice_tests: {
    namespace: "PracticeTest",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "practice_tests"
      },
      update: {
        method: "PUT",
        path: "practice_tests/#{id}"
      },
      delete: {
        method: "DELETE",
        path: "practice_tests/#{id}"
      },
      create: {
        method: "POST",
        path: "practice_tests"
      },
      correct: {
        method: "POST",
        path: "practice_tests/#{id}/correct"
      },
      create_and_render: {
        method: "POST",
        path: "practice_tests/#{id}/duplicate/create_and_render"
      }
    }
  },
  resolveds: {
    namespace: "Resolved",
    custom: true,
    actions: {
      mass_destroy_all: { method: "DELETE", path: "resolveds/mass_destroy_all" },
      mass_destroy: { method: "DELETE", path: "resolveds/mass_destroy" }
    }
  },
  commentaries: {
    namespace: "Commentary",
    custom: true,
    actions: {
      get_all: { method: "GET", path: "questions/#{question_id}/commentaries" },
      create: { method: "POST", path: "questions/#{question_id}/commentaries" },
      create_and_render: {
        method: "POST",
        path: "questions/#{question_id}/commentaries/create_and_render"
      },
      update: {
        method: "PUT",
        path: "questions/#{question_id}/commentaries/#{id}"
      },
      update_and_render: {
        method: "PUT",
        path: "questions/#{question_id}/commentaries/#{id}/update_and_render"
      },
      like: {
        method: "PUT",
        path: "questions/#{question_id}/commentaries/#{id}/like"
      },
      unlike: {
        method: "PUT",
        path: "questions/#{question_id}/commentaries/#{id}/unlike"
      },
      update_like: {
        method: "PUT",
        path: "questions/#{question_id}/commentaries/#{id}/update_like"
      },
      report_abuse: {
        method: "POST",
        path: "questions/#{question_id}/commentaries/#{id}/report_abuse"
      },
      recommend: {
        method: "POST",
        path: "recommendation/"
      },
      unrecommend: {
        method: "DELETE",
        path: "recommendation/#{id}"
      },
      delete: {
        method: "DELETE",
        path: "questions/#{question_id}/commentaries/#{id}"
      }
    }
  },
  conversations: {
    namespace: "Conversation",
    custom: true,
    actions: {
      list: { method: "GET", path: "conversations" },
      create: { method: "POST", path: "conversations" },
      delete: { method: "DELETE", path: "conversations/#{id}" },
      read_messages: {
        method: "PUT",
        path: "conversations/#{id}/read_messages"
      }
    }
  },
  league: {
    namespace: "League",
    custom: true,
    actions: {
      join: { method: "POST", path: "league_agreement" },
      quit: { method: "DELETE", path: "league_agreement" }
    }
  },
  messages: {
    namespace: "Message",
    custom: true,
    actions: {
      list: {
        method: "GET",
        path: "conversations/#{conversation_id}/messages"
      },
      create: {
        method: "POST",
        path: "conversations/#{conversation_id}/messages"
      },
      delete: {
        method: "DELETE",
        path: "conversations/#{conversation_id}/messages/#{id}"
      },
      read: {
        method: "PUT",
        path: "conversations/#{conversation_id}/messages/#{id}/read"
      }
    }
  },
  lesson_feedbacks: {
    namespace: "LessonFeedback",
    actions: {
      create: { method: "POST", path: "lesson_feedbacks" },
      update: { method: "PUT", path: "lesson_feedbacks/#{id}" }
    }
  },
  carts: {
    namespace: "Cart",
    actions: {
      show: { method: "GET", path: "cart" },
      update: { method: "PATCH", path: "cart" },
      delete: { method: "DELETE", path: "cart" }
    }
  },
  orders: {
    namespace: "Order",
    custom: true,
    actions: {
      list: { method: "GET", path: "orders" },
      show: { method: "GET", path: "orders/#{order_number}" },
      create: { method: "POST", path: "orders" },
      update: { method: "PATCH", path: "orders/#{order_number}" },
      delete: { method: "DELETE", path: "orders/#{order_number}" },
      pay: { method: "POST", path: "orders/#{order_number}/payments" },
      refundPayment: {
        method: "POST",
        path: "orders/#{order_number}/payments/#{payment_id}/refund"
      }
    }
  },
  recurrences: {
    namespace: "Recurrence",
    custom: true,
    actions: {
      cancel: { method: "POST", path: "recurrences/#{id}/cancel" },
      pause: { method: "PUT", path: "recurrences/#{id}/pause" },
      resume: { method: "PUT", path: "recurrences/#{id}/resume" }
    }
  },
  cities: {
    namespace: "City",
    actions: {
      list: { method: "GET", path: "cities" }
    }
  },
  share: {
    namespace: "Share",
    actions: {
      create: { method: "POST", path: "share" }
    }
  },
  lessons: {
    namespace: "Lesson",
    actions: {
      show: { method: "GET", path: "lessons/#{id}" },
      list: { method: "GET", path: "lessons" }
    }
  },
  user_lesson_progress: {
    namespace: "UserLessonProgress",
    actions: {
      update: { method: "PATCH", path: "lessons/#{lesson_id}/progress" }
    }
  },
  user_preferences: {
    namespace: "UserPreference",
    actions: {
      show: {
        method: "GET",
        path: "user_preferences"
      },
      update: {
        method: "PATCH",
        path: "user_preferences"
      }
    }
  },
  user_onboards: {
    namespace: "UserOnboards",
    actions: {
      show: {
        method: "GET",
        path: "user_onboards"
      },
      create: {
        method: "POST",
        path: "user_onboards"
      }
    }
  },
  deprecated_orders: {
    namespace: "DeprecatedOrders",
    actions: {
      list: { method: "GET", path: "deprecated_orders" }
    }
  },
  question_maintenances: {
    namespace: "QuestionMaintenances",
    actions: {
      create: { method: "POST", path: "ils/question_maintenances" }
    }
  },
  excerpts: {
    namespace: "Excerpts",
    actions: {
      list: { method: "GET", path: "ils/excerpts" }
    }
  },
  mind_maps: {
    namespace: "MindMaps",
    actions: {
      list: { method: "GET", path: "ils/mind_maps" },
      show: { method: "GET", path: "ils/mind_maps/#{id}" },
      create: { method: "POST", path: "ils/mind_maps" },
      delete: { method: "DELETE", path: "ils/mind_maps/#{id}" }
    }
  },
  mind_maps_like: {
    namespace: "MindMapsLike",
    actions: {
      update: { method: "PATCH", path: "ils/mind_maps/#{id}/like" },
      delete: { method: "DELETE", path: "ils/mind_maps/#{id}/like" }
    }
  },
  markings: {
    namespace: "Marking",
    actions: {
      list: { method: "GET", path: "ils/markings" },
      show: { method: "GET", path: "ils/markings/#{id}" },
      create: { method: "POST", path: "ils/markings" },
      update: { method: "PATCH", path: "ils/markings/#{id}" },
      delete: { method: "DELETE", path: "ils/markings/#{id}" }
    }
  },
  chapters: {
    namespace: "Chapter",
    custom: true,
    actions: {
      complete: { method: "POST", path: "ils/chapters/#{id}/complete" },
      uncomplete: { method: "DELETE", path: "ils/chapters/#{id}/complete" }
    }
  },
  chapter_resolveds: {
    namespace: "ChapterResolveds",
    actions: {
      create: { method: "POST", path: "ils/chapter_resolveds" }
    }
  },
  inquiries: {
    namespace: "Inquiry",
    actions: {
      list: { method: "GET", path: "ils/inquiries" },
      create: { method: "POST", path: "ils/inquiries" },
      update: { method: "PATCH", path: "ils/inquiries/#{id}" },
      delete: { method: "DELETE", path: "ils/inquiries/#{id}" }
    }
  },
  tasks: {
    namespace: "Tasks",
    actions: {
      create: { method: "POST", path: "ils/tasks" },
      update: { method: "PATCH", path: "ils/tasks/#{id}" },
      list: { method: "GET", path: "ils/tasks" }
    }
  },
  onboarding: {
    namespace: "Onboarding",
    actions: {
      create: { method: "POST", path: "ils/onboarding" }
    }
  },
  user_favorite_tracks: {
    namespace: "UserFavoriteTracks",
    actions: {
      create: { method: "POST", path: "ils/user_favorite_tracks" },
      delete: { method: "DELETE", path: "ils/user_favorite_tracks" }
    }
  },
  topic_downloads: {
    namespace: "TopicDownloads",
    actions: {
      create: { method: "POST", path: "ils/topics/#{topic_id}/download" }
    }
  },
  topic_pdf: {
    namespace: "TopicPdf",
    actions: {
      create: { method: "POST", path: "ils/topics/#{topic_id}/print" }
    }
  },
  topic_videos_visit: {
    namespace: "TopicVideosVisit",
    actions: {
      create: { method: "POST", path: "ils/topic_videos/#{topic_video_id}/visit" },
      delete: { method: "DELETE", path: "ils/topic_videos/#{topic_video_id}/visit" }
    }
  },
  filters: {
    namespace: "Filter",
    actions: {
      show: { method: "GET", path: "filters/#{product}" }
    }
  },
  forum_replies: {
    namespace: "ForumReplies",
    actions: {
      create: { method: "POST", path: "ils/forum/replies" },
      delete: { method: "DELETE", path: "ils/forum/replies/#{id}" }
    }
  },
  forum_votes: {
    namespace: "ForumVotes",
    actions: {
      update: { method: "PUT", path: "ils/forum/#{type}/#{id}/vote" },
      delete: { method: "DELETE", path: "ils/forum/#{type}/#{id}/vote" }
    }
  },
  forum_posts: {
    namespace: "ForumPosts",
    actions: {
      create: { method: "POST", path: "ils/forum/posts" },
      update: { method: "PUT", path: "ils/forum/posts/#{id}" },
      delete: { method: "DELETE", path: "ils/forum/posts/#{id}" }
    }
  },
  visits: {
    namespace: "Visits",
    actions: {
      create: { method: "POST", path: "visits" }
    }
  },
  performance: {
    namespace: "Performance",
    custom: true,
    actions: {
      general: { method: "GET", path: "performance" },
      chapter: {
        method: 'GET',
        path: "ils/chapter_performance"
      }
    }
  },
  highlights: {
    namespace: "Highlight",
    actions: {
      list: {
        method: "GET",
        path: "highlights"
      },
      update: {
        method: "PUT",
        path: "highlights/#{id}"
      },
      delete: {
        method: "DELETE",
        path: "highlights/#{id}"
      },
      create: {
        method: "POST",
        path: "highlights"
      }
    }
  },
  folders: {
    namespace: "NotebooksFolders",
    actions: {
      list: { method: "GET", path: "folders" },
      show: { method: "GET", path: "folders/#{id}" },
      create: { method: "POST", path: "folders" },
      delete: { method: "DELETE", path: "folders/#{id}" }
    }
  },
  ranking_entry: {
    namespace: "RankingEntry",
    actions: {
      create: { method: "POST", path: "rankings/#{id}/entries" }
    }
  },
  performance_targets: {
    namespace: "PerformanceTarget",
    actions: {
      show: { method: "GET", path: "performance_targets" },
      create: { method: "POST", path: "performance_targets" }
    }
  },
  ils_practice_tests: {
    namespace: "IlsPracticeTest",
    actions: {
      create: { method: "POST", path: "ils/practice_tests/#{type}" },
      delete: { method: "DELETE", path: "ils/practice_tests/#{id}" }
    }
  },
  ils_practice_tests_attempts: {
    namespace: "IlsPracticeTestsAttempt",
    actions: {
      create: { method: "POST", path: "ils/practice_tests/attempts" },
      complete: { method: "POST", path: "ils/practice_tests/attempts/#{id}/complete" }
    }
  },
  ils_practice_tests_attempt_questions: {
    namespace: "IlsPracticeTestsAttemptQuestions",
    actions: {
      update: { method: "PUT", path: "ils/practice_tests/attempts/#{attemptId}/questions/#{id}" }
    }
  },
  user_xrays: {
    namespace: "UserXrays",
    actions: {
      create: { method: "POST", path: "xrays/user_xrays" },
      delete: { method: "DELETE", path: "xrays/user_xrays/#{id}" }
    }
  },
  study_blocks: {
    namespace: "StudyBlocks",
    actions: {
      list: { method: "GET", path: "ils/study_plans/blocks" },
      create: { method: "POST", path: "ils/study_plans/blocks" },
      check: { method: "PUT", path: "ils/study_plans/block_occurrences/#{id}/complete" },
      uncheck: { method: "DELETE", path: "ils/study_plans/block_occurrences/#{id}/reset" }
    }
  },
  block_occurrences: {
    namespace: "BlockOccurrences",
    actions: {
      update: { method: "PUT", path: "ils/study_plans/block_occurrences/#{id}" },
      delete: { method: "DELETE", path: "ils/study_plans/block_occurrences/#{id}" }
    }
  },
  study_types: {
    namespace: "StudyType",
    actions: {
      check: { method: "POST", path: "ils/study_plans/block_occurrence_study_types" },
      uncheck: { method: "DELETE", path: "ils/study_plans/block_occurrence_study_types" }
    }
  },
  study_plans: {
    namespace: "StudyPlans",
    actions: {
      silence: { method: "POST", path: "ils/study_plans/study_plans/silence" },
      delete: { method: "DELETE", path: "ils/study_plans/study_plans" }
    }
  },
  oriented_study_contract: {
    namespace: "OrientedStudyContract",
    actions: {
      create: { method: "POST", path: "ils/oriented_study/contract" },
      update: { method: "PUT", path: "ils/oriented_study/contract/#{id}" }
    }
  },
  oriented_study_progress: {
    namespace: "OrientedStudyProgress",
    actions: {
      create: { method: "POST", path: "ils/oriented_study/contract/#{contractId}/progress" },
      delete: { method: "DELETE", path: "ils/oriented_study/contract/#{contractId}/progress" }
    }
  },
  oriented_study_progress_bulk: {
    namespace: "OrientedStudyProgressBulk",
    actions: {
      create: { method: "POST", path: "ils/oriented_study/contract/#{contractId}/progress/bulk" },
      delete: { method: "DELETE", path: "ils/oriented_study/contract/#{contractId}/progress/bulk" }
    }
  },
  coach_practice_tests: {
    namespace: "CoachPracticeTest",
    actions: {
      create: { method: "POST", path: "ils/coach/practice_tests" }
    }
  },
  coach_notebooks: {
    namespace: "CoachNotebook",
    actions: {
      create: { method: "POST", path: "ils/coach/notebooks" }
    }
  },
  user_trials: {
    namespace: "UserTrial",
    actions: {
      create: { method: "POST", path: "user_trial" }
    }
  },
  olympics_agreement: {
    namespace: "OlympicsAgreement",
    actions: {
      create: { method: "POST", path: "olympic_agreements" }
    }
  },
  bnpl: {
    namespace: "Bnpl",
    custom: true,
    actions: {
      authorize: {
        method: "POST",
        path: "checkout/bnpl/authorization"
      }
    }
  },
  cards: {
    namespace: "Cards",
    custom: true,
    actions: {
      create: { method: "POST", path: "/cards/" },
      list: { method: "GET", path: "/cards" },
      init: { method: "GET", path: "/cards/init" },
      show: { method: "GET", path: "/cards/#{id}" },
      default: { method: "PUT", path: "/cards/default" }
    }
  }
};